import {ENT_REQUIRED_FIELDS} from '../dictionary';

function isStaff(profile) {
  return (
    (profile && profile.staff_type === 'staff') || profile.staff_type === 'root'
  );
}

function isReviewer(profile) {
  return profile && profile.staff_type === 'reviewer';
}

function isVIP(profile) {
  return profile && profile.user_type.indexOf('vip') >= 0;
}

function isEnt(profile) {
  return profile && profile.user_type.indexOf('ent') >= 0;
}

function isMonthly(profile) {
  return profile.user_type.indexOf('monthly') >= 0;
}

function buildProfilePayload(userConfig) {
  return {
    address: userConfig.address,
    city: userConfig.city,
    district: userConfig.district,
    name: userConfig.name,
    phone: userConfig.phone,
    zip: userConfig.zip_code,
    zip_code: userConfig.zip_code,
  };
}

function fillEntFieldsFromProfile(data, profile) {
  if (!profile || profile.user_type !== 'enterprise') {
    return data;
  }

  const result = {...data};
  let entData = {};
  try {
    entData = JSON.parse(profile.data || '{}');
  } catch (ex) {
    console.warn('攤平企業資料失敗:', ex);
  }

  for (const field of ENT_REQUIRED_FIELDS) {
    if (result[field] === undefined || result[field] === null) {
      const val = entData[field] ?? profile[field];
      if (val !== undefined && val !== null) {
        result[field] = val;
      }
    }
  }

  return result;
}

function validateEntFields(data, profile) {
  if (!profile || profile.user_type !== 'enterprise') {
    return {valid: true, missingFields: []};
  }

  const missingFields = ENT_REQUIRED_FIELDS.filter((field) => {
    const value = data[field];
    return value === undefined || value === null || value === '';
  });

  return {valid: missingFields.length === 0, missingFields};
}

export {
  isStaff,
  isReviewer,
  isVIP,
  isEnt,
  isMonthly,
  buildProfilePayload,
  fillEntFieldsFromProfile,
  validateEntFields,
};
